import { ApiResponse } from "../interfaces/Api";
import { Room, RoomFormValues, RoomType } from "../interfaces/RoomInterface";
import { TWardType } from "../interfaces/WardInterface";
import { Get, Post, Patch, Delete } from "./apiHelper";

const roomsRoot = "/api/rooms";

export const getRooms = async ({
  resourceCentreId,
  type,
  wardIds = [],
  wardType
}: {
  resourceCentreId: number;
  wardIds?: Array<number>;
  type?: RoomType;
  wardType?: TWardType;
}): Promise<ApiResponse<Array<Room>>> => {
  const query = new URLSearchParams();

  query.append("resourceCentreId", resourceCentreId.toString());
  if (wardIds?.length > 0) query.append("wardIds", wardIds.join(",").toString());
  if (type) query.append("type", type.toString());
  if (wardType) query.append("wardType", wardType.toString());

  const result = await Get(`${roomsRoot}?${query.toString()}`, true);
  return result.data as ApiResponse<Array<Room>>;
};

// post room
export async function postRoom(data: RoomFormValues): Promise<ApiResponse<Room>> {
  const response = await Post(`${roomsRoot}`, data, true);
  return response.data as ApiResponse<Room>;
}

// patch room
export async function patchRoom({
  id,
  data
}: {
  id: number | string;
  data: RoomFormValues;
}): Promise<ApiResponse<Room>> {
  const response = await Patch(
    `${roomsRoot}/${id}`,
    data as unknown as Record<string, unknown>,
    true
  );
  return response.data as ApiResponse<Room>;
}

// delete room
export async function deleteRoom(id: number | string): Promise<ApiResponse<null>> {
  const response = await Delete(`${roomsRoot}/${id}`, true);
  return response.data as ApiResponse<null>;
}
